import { render, staticRenderFns } from "./informationOut.vue?vue&type=template&id=06f7487c&scoped=true&"
import script from "./informationOut.vue?vue&type=script&lang=js&"
export * from "./informationOut.vue?vue&type=script&lang=js&"
import style0 from "./informationOut.vue?vue&type=style&index=0&id=06f7487c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f7487c",
  null
  
)

export default component.exports